import React from 'react';

export { XtSp };


function XtSp() { // extra thin space ("hair space")
  return (
    <>&#8202;</>
  );
}
